import React from 'react';
import { FormattedMessage } from 'react-intl';
import { rem, size } from 'polished';
import styled from 'styled-components';

import { breakpoints, misc } from 'helpers/styles/constants';
import { GenericTitle, TitleMargin } from 'components/GenericTitle/GenericTitle';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${breakpoints.smUp} {
    flex-direction: row;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: ${rem(43)};
    width: ${rem(12)};

    @media ${breakpoints.smUp} {
      left: ${rem(-52)};
    }

    @media ${breakpoints.mdUp} {
      left: ${rem(-105)};
    }
  }

  &::before {
    top: ${rem(25)};
    z-index: ${misc.zIndex1};
    height: ${rem(12)};
    background-color: ${({ theme }) => theme.colors.main};
    opacity: 0.3;
    border-radius: 50%;
  }

  &::after {
    top: 0;
    height: ${rem(60)};
    background-color: ${({ theme }) => theme.colors.white};
  }

  &:first-child {
    &::after {
      top: 0;
    }
  }

  &:last-child {
    &::after {
      height: 100%;
    }
  }

  &:not(:last-child) {
    margin-bottom: ${rem(80)};
  }
`;

const Titles = styled.div`
  flex: 0 1 100%;

  @media ${breakpoints.smUp} {
    flex-basis: 40%;
  }
`;

const Description = styled.div`
  margin-top: ${rem(30)};
  margin-bottom: 0;
  line-height: 1.66;
`;

const Icon = styled.div`
  flex: 0 0 100%;
  margin-top: ${rem(30)};

  @media ${breakpoints.smUp} {
    flex-basis: 40%;
  }

  svg {
    @media ${breakpoints.smDown} {
      ${size('100%')};
      max-width: ${rem(320)};
    }
  }
`;

interface Props {
  icon: React.ReactNode;
  index: number;
  translationKey: string;
  hasSubtitle?: boolean;
}

const SectionItem = ({ icon, index, translationKey, hasSubtitle }: Props) => (
  <Wrapper>
    <Titles>
      <GenericTitle as="h3" marginBottom={TitleMargin.Lg} hasBottomLine isColoredMain isBig>
        {`${index}.`}
      </GenericTitle>

      <GenericTitle as="h4" marginBottom={TitleMargin.Sm} hasSubheaderColor isMediumLg>
        <FormattedMessage id={`${translationKey}.section${index}.title`} />
      </GenericTitle>

      {hasSubtitle && (
        <Description>
          <FormattedMessage id={`${translationKey}.section${index}.subtitle`} />
        </Description>
      )}
    </Titles>

    {icon && <Icon>{icon}</Icon>}
  </Wrapper>
);

export default SectionItem;
